import PropTypes from "prop-types";
import { useMatchMedia } from "../../hooks";
import { withTranslation } from "../../translation";
import styles from "./index.css";

const FeaturedCategoryHeaderTitleOverlay = ({
  headerTitle,
  headerDisplayText = "",
  scrollFunction,
  formatTranslation,
}) => {
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion)");
  const buttonLabel =
    headerDisplayText || formatTranslation("plp_featured_header_cta");

  return (
    <div className={styles.titleOverlay}>
      <h1 className={styles.headerTitle}>{headerTitle}</h1>
      <button
        className={styles.scrollToButton}
        onClick={scrollFunction}
        aria-label={buttonLabel}
      >
        {headerDisplayText && (
          <span className={styles.scrollToText}>{headerDisplayText}</span>
        )}
        <span
          aria-hidden="true"
          className={!prefersReducedMotion ? styles.scrollToIcon : undefined}
        />
      </button>
    </div>
  );
};

FeaturedCategoryHeaderTitleOverlay.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerDisplayText: PropTypes.string,
  scrollFunction: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(FeaturedCategoryHeaderTitleOverlay);
